import { useState } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { validateEmail } from '../../global/helpers/global-helpers';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import { displayEmoji } from '../helpers/dsr-helpers';
import LaunchdeckFormInput from '../../forms/TextInputField/components/LaunchdeckFormInput';
import useFeNotificationSender from '../../global/hooks/send-fe-slack-notification';


export default function DsrAccessSetPasswordForm({
	newUserId,
	newProfileToken,
	defaultEmail,
	handleSetPasswordProfile
}) {

	const {sendFeErrorNotification} = useFeNotificationSender();

	const [emailInput, setEmailInput] = useState(defaultEmail);
	const [newPasswordInput, setNewPasswordInput] = useState('');
	const [confirmPasswordInput, setConfirmPasswordInput] = useState('');
	const [showPasswordError, setShowPasswordError] = useState('');

	const [showInputError, setShowInputError] = useState(false);
	const [showValidationError, setShowValidationError] = useState(false);

	const [showGetNameForm, setShowGetNameForm] = useState(false)
	const [showNoNameError, setShowNoNameError] = useState(false)
	const [firstNameInput, setfirstNameInput] = useState("")
	const [lastNameInput, setLastNameInput] = useState("")

	const [isProcessing, setIsProcessing] = useState(false)


	//Function
	const handleSetNewPassword = () => {
		resetAllErrorStates()
		const isValidEmail = validateEmail(emailInput);
		let passValidation = true;

		if (!isValidEmail) {
			setShowInputError(true)
			passValidation = false;
		}

		if (!newPasswordInput || newPasswordInput.length < 6) {
			setShowPasswordError(true)
			passValidation = false;
		}

		if (!confirmPasswordInput || (newPasswordInput !== confirmPasswordInput)) {
			setShowValidationError(true)
			passValidation = false;
		}

		if (newPasswordInput && isValidEmail && newUserId && !!passValidation) {
			setShowGetNameForm(true)
		}
	}

	const handleCompleteSetProfile = () => {
		resetAllErrorStates()
		const trimmedFirstNameInput = firstNameInput.trim()
		const trimmedLastNameInput = lastNameInput.trim()
		
		if (!trimmedFirstNameInput) {
			setShowNoNameError(true)
		} else {
			if (newProfileToken) {
				handleSetPasswordProfile(newPasswordInput, newProfileToken, trimmedFirstNameInput, trimmedLastNameInput)
				setIsProcessing(true)
			} else {

				sendFeErrorNotification("M0HZMZ", "No token provided to set up profile", {
					userIdToken: newUserId,
					orgId: "",
					internalNotes: "Check for user's pwtoken",
					errorReportMetadata: {}
				})
			}
			
		}
	}

	const resetAllErrorStates = () => {
		setShowInputError(false)
		setShowPasswordError(false)
		setShowValidationError(false)
		setShowNoNameError(false)
	}

	const onChangeHandler = (event) => {

		switch (event.target.name) {
			case ('email'): {
				showValidationError && setShowValidationError(false)
				setEmailInput(event.target.value.trim())
				break;
			}
			case ('password-input'): {
				showPasswordError && setShowPasswordError(false)
				setNewPasswordInput(event.target.value)
				break;
			}
			case ('repeat-password'): {
				showValidationError && setShowValidationError(false)
				setConfirmPasswordInput(event.target.value)
				break;
			}
			case ('firstName'): {
				showNoNameError && setShowNoNameError(false)
				setfirstNameInput(event.target.value)
				break;
			}
			case ('lastName'): {
				setLastNameInput(event.target.value)
				break;
			}
			default: {
				break;
			}
		}
	};


	if (showGetNameForm) {
		return (
			<>
				<Box textAlign='center' fontSize='1.5em' color='brandDark.500'>Introduce yourself {displayEmoji('wave')}</Box>
				<Box textAlign='center' fontSize='0.875em' color='gray.500' fontWeight='400' lineHeight='1.375em' mb='3.5em'>Help others know how to address you</Box>

				<Flex w="100%" px='1em' mt='1em' direction='column' align="center" gap='0.8em' className='fade-in'>


					<LaunchdeckFormInput
						label='First name'
						name={'firstName'}
						onChange={onChangeHandler}

						value={firstNameInput}
						isRequired={true}
						isDisabled={isProcessing}

						errorLogic={showNoNameError}
					/>

					<LaunchdeckFormInput
						label='Last name'
						name={'lastName'}
						onChange={onChangeHandler}

						value={lastNameInput}
						isRequired={true}
						isDisabled={isProcessing}

						errorLogic={showNoNameError}
						errorMessage={'Please help others know how to address you'}
					/>

					<Flex w='100%' mt='2em' align='center' maxW='25em' direction='column' gap='0.5em'>
						<LaunchdeckButton bg='brand.500' color='gray.50' w='100%' label='Enter Room' onClick={() => handleCompleteSetProfile()} />
						<Box color='gray.500' cursor='pointer' fontSize='0.8em' onClick={() => setShowGetNameForm(false)}>Back</Box>
					</Flex>
				</Flex>
			</>
		)
	} else {
		return (
			<>
				<Box textAlign='center' fontSize='1.5em' color='brandDark.500' mb='0.5em'>Set a password</Box>
				<Box textAlign='center' fontSize='0.875em' color='gray.500' fontWeight='400' lineHeight='1.375em' mb='3.5em'>It'll help you access this Room more easily in the future </Box>

				<Flex w="100%" px='1em' mt='1em' direction='column' align="center" gap='1em' className='fade-in'>
					<LaunchdeckFormInput
						label='Email'
						name={'email'}
						onChange={onChangeHandler}

						value={emailInput}
						isRequired={true}
						isDisabled={validateEmail(emailInput)}

						errorLogic={showInputError}
						errorMessage={'Please provide a valid email'}
					/>

					<LaunchdeckFormInput
						label='Password'
						name={'password-input'}
						onChange={onChangeHandler}

						value={newPasswordInput}
						isRequired={true}
						type='password'

						errorLogic={showPasswordError}
						errorMessage={'Please set a secure password that contains more than 6 characters'}
					/>

					<LaunchdeckFormInput
						label='Confirm password'
						name={'repeat-password'}
						onChange={onChangeHandler}

						value={confirmPasswordInput}
						isRequired={true}
						type='password'

						errorLogic={showValidationError}
						errorMessage={'Your confirmation password did not match.'}
					/>

					<Flex w='100%' mt='2em'>
						<LaunchdeckButton bg='brand.500' color='gray.50' w='100%' label='Set password' onClick={() => handleSetNewPassword()} />
					</Flex>
				</Flex>
			</>
		);
	}

};